// Generated by scripts/icons/build-icon-components.mjs from the matching
// file in ./svg — edit the SVG and re-run the script, not this file.
import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';

const TagLocationIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <g fill="currentColor">
      <path
        fillRule="evenodd"
        d="M18.02 4.12C16.38 2.43 14.24 1.5 12 1.5s-4.38.93-6.02 2.63C4.31 5.85 3.4 8.15 3.47 10.46c.2 6.55 7.9 11.64 8.24 11.85l.29.2.29-.2c.33-.2 8.04-5.17 8.24-11.85.07-2.3-.84-4.62-2.51-6.34"
        opacity=".5"
      />
      <path d="M9.07 10.67c0 1.62 1.31 2.93 2.93 2.93s2.93-1.31 2.93-2.93S13.62 7.74 12 7.74s-2.93 1.31-2.93 2.93" />
    </g>
  </SvgIcon>
);

export default TagLocationIcon;
